// Imported first by src/index.js: modules read the authentication URL when they load, so the choice
// must be made before any of them does.
import { AUTH_PR_GLOBAL, applyAuthPreview } from './authPreview';

if (process.env.REACT_APP_WOOSMAP_ENV === 'develop') {
    try {
        window[AUTH_PR_GLOBAL] = applyAuthPreview(window, window.localStorage);
    } catch (e) {
        // Storage refused (private mode, blocked site data): stay on the built authentication URL.
    }
}
